import React, { useEffect, useRef, useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  TablePagination,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import "../../tag_status.css"
// components
import CloseIcon from "@material-ui/icons/Close";
import PageTitle from "../../components/PageTitle";
import GetAppIcon from "@material-ui/icons/GetApp";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import MessageIcon from '@material-ui/icons/Message';
// data
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CustomPdfView from "../../components/pdfViewer/CustomPdfView.js";
import { getFileExtension } from "../../utils/getextension.js";


export default function RecCoinHistory() {

  const classes = useStyles();
  const mobileQuery = useMediaQuery('(max-width:600px)');
  const token = localStorage.getItem("token");
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [requirementsData, setRequirementsData] = useState([]);

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [reasonOpen, setReasonOpen] = React.useState(false);
  const [invoicePDF, setInvoicePDF] = React.useState("");
  const [rejectReason, setRejectReason] = React.useState("");

  const invoiceUrl = invoicePDF;
  const fileExtension = invoiceUrl ? getFileExtension(invoiceUrl) : null;

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleModalOpen = (invoice) => {
    setModalOpen(true);
    setInvoicePDF(invoice)
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/viewAllInvoices`,
        data: {
          page: 1,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {

        if (response.data.status === true) {
          setLoader(false);
          setRequirementsData(response.data.data);
          setCount(response.data.count);
        }
      }).catch((error) => {
        console.log(error);
        setLoader(false);
      })
    };
    fetchData();
    // setRequirementsData([
    //   {
    //     id: "6b091ca3-4765-4406-aa90-86773c65973f",
    //     uniqueId: "128903-12312-234-2123-4234323123",
    //     redeemValue: "130",
    //     status: "REJECTED",
    //     inrValue: "650",
    //     "createdAt": "2024-07-18T12:01:29.176Z",
    //     "updatedAt": "2024-07-18T12:01:29.176Z",
    //   },
    //   {
    //     id: "6b091ca3-4765-4406-aa90-35773c65973f",
    //     uniqueId: "1289231-12312-234-2123-4234323123",
    //     redeemValue: "150",
    //     status: "REEDMED",
    //     inrValue: "650",
    //     "createdAt": "2024-07-18T12:01:29.176Z",
    //     "updatedAt": "2024-07-18T12:01:29.176Z",
    //   }
    // ]);
  }, [token]);

  const [requirementId, setRequirementId] = useState(null);

  const filterRef = useRef(null);

  function getApprovalStatusColor(status) {
    let className;
    switch (status) {
      case "PENDING":
        className = "neutral-extrahigh"
        break;
      case "PAID":
        className = "positive-medium"
        break;
      case "REJECTED":
        className = "critical-low"
        break;
      default:
        className = "neutral-extrahigh"
        break;
    }
    return className;
  }

  const blinkIteration = {
    "--iteration-count": "infinite",
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    const form = filterRef.current;
    var data = JSON.stringify({
      page: newPage + 1,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      requirementId: requirementId?.requirement?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/myAssignedRequirements`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setRequirementsData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  const HeaderElements = () => (
    <>
      <Grid className={classes.HeaderElements}>
        Total : {count}
      </Grid>
    </>
  );


  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Invoiced Status" />
        </Grid>

        <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>

          {/* <SwipeableDrawer
            anchor="right"
            open={state["right"]}
            onClose={toggleDrawer("right", false)}
            onOpen={toggleDrawer("right", true)}
            classes={{ paper: classes.drawer }}
          >
          </SwipeableDrawer> */}
        </Grid>
      </Grid>

      {/* <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>

          <Autocomplete
            className={classes.filterFullWidth}
            options={requirementsData}
            getOptionLabel={(option) =>
              option.requirement?.requirementName + " (" + option.requirement?.uniqueId + ")"
            }
            // size="small"
            value={requirementId}
            onChange={(event, value) => setRequirementId(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                name="requirementId"
                label="Requirement"
                size="small"
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

          <TextField
            name="fromDate"
            label="From"
            InputLabelProps={{ shrink: true }}
            size="small"
            type="date"
            defaultValue={fromDate}
            onChange={handleFromDateChange}
            className={classes.filterWidth}

          />

          <TextField
            name="toDate"
            label="To"
            InputLabelProps={{ shrink: true }}
            size="small"
            type="date"
            defaultValue={toDate}
            onChange={handleToDateChange}
            className={classes.filterWidth}

          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              type="submit"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form> */}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? 'vertical' : 'standard',
              textLabels: {
                body: {
                  noMatch: 'Oops! Matching record could not be found',
                }
              },
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Inoice ID",
                // options: {
                //   customHeadLabelRender: (columnMeta) => renderHeaderWithIcon(
                //     <RecCoinTooltip
                //       title={
                //         <React.Fragment>
                //           <Typography color="inherit">Coin Values</Typography>
                //           <>{"RecCoin per CV Share"}</>{'/'} <br />
                //           <>{"RecCoin per Final Interview Turn-up"}</>{'/'} <br />
                //           <>{"RecCoin per Candidate Hired"}</>
                //         </React.Fragment>
                //       }
                //     >
                //       <IconButton size="small">
                //         <img src={info_icon_svg} style={{ width: '18px', height: "18px" }} alt="coin" />
                //       </IconButton>
                //     </RecCoinTooltip>,
                //     "Inoice ID",
                //   ),
                // }
              },
              {
                name: "Transaction Number",
              },
              {
                name: "Invoice Status",
              },

              {
                name: "Invoice Amount ",
              },
              {
                name: "Invoice ",
              },
              {
                name: "Posted Date",
              },
            ]}
            data={requirementsData && requirementsData.map((item, index) => {
              return [
                <>
                  {currerntPage !== 0 ? 10 * currerntPage - 10 + index + 1 : index + 1}
                </>,
                <>
                  {item.uniqueId}
                </>,
                <>
                  {item.status === "PAID" ? (
                    `${item?.transactionNumber && item?.transactionNumber}`

                  ) : "-"}
                </>,
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
                  <div className={`status-tag ${getApprovalStatusColor(item.status)}`}>
                    <i
                      className={`highlight ${getApprovalStatusColor(item.status)}`}
                      style={blinkIteration}
                    ></i>
                    <p className='status-tag__txt bac-l-stack-xs' style={{ textTransform: 'capitalize' }}>{item.status}</p>
                  </div>

                  {item.status === "REJECTED" && (
                    <Tooltip
                      title="Reason"
                      placement="bottom"
                      aria-label="reason"
                    >
                      <MessageIcon className={classes.toolIcon} onClick={() => { setReasonOpen(true); setRejectReason(item.rejectReason) }} />
                    </Tooltip>
                  )}
                </div>,
                item.totalValue,
                <div key={index} style={{ display: 'flex', gap: "5px" }}>
                  <Tooltip
                    title="View Invoice"
                    placement="bottom"
                    aria-label="view"
                  >
                    <RemoveRedEyeIcon
                      className={classes.toolIcon}
                      onClick={() => handleModalOpen(item.invoice)}
                    />
                  </Tooltip>
                  <Tooltip
                    title="Downlaod Invoice"
                    placement="bottom"
                    aria-label="downlaod"
                  >
                    <a className={classes.messageContent} href={item.invoice} download>

                      <GetAppIcon className={classes.toolIcon} />
                    </a>
                  </Tooltip>
                </div>,
                moment(item.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleModalClose}
        open={modalOpen}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}>
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Invoice
              </Typography>
              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon className={classes.closeBtn} onClick={handleModalClose} />
              </div>
            </div>
            <Grid item xs={12}>
              {fileExtension === "pdf" ?
                <CustomPdfView resumeUrl={invoicePDF} />
                :
                <div className={classes.iframediv} style={{ marginTop: "40px" }}>
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      invoicePDF +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%" height="500" sandbox="allow-scripts allow-same-origin"
                  >
                  </iframe>
                  <div className={classes.iframeLogo} >
                  </div>
                </div>
              }
            </Grid>

            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button variant="contained" size="small" color="secondary" onClick={handleModalClose}>
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        aria-labelledby="dialog-title"
        open={reasonOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
              style={{ fontSize: "1.3rem" }}
            >
              Reject Reason
            </Typography>
            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={() => { setReasonOpen(false); setRejectReason("") }}
              />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" style={{ fontSize: "1rem" }}>
            Your Invoice Was Rejected
          </Typography>
          <Typography variant="body1" style={{ fontSize: "0.85rem", padding: "15px 0" }}>
            {rejectReason}
          </Typography>
          <Typography variant="body1" style={{ fontSize: "0.75rem", fontStyle: "italic" }}>
            Please resolve your issue and submit the invoice once more.
          </Typography>
          <Grid className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => { setReasonOpen(false); setRejectReason("") }}
            >
              Close
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

